/**
 * Навыки агентов: данные для каталога /skills.
 *
 * Манифест и сами SKILL.md генерируются из docs/skills скриптом
 * scripts/sync-skills.mjs (запускается в npm run dev/build) — руками файлы в
 * src/content/skills не правятся.
 */
import manifest from "../content/skills/manifest.json";

export interface SkillEntry {
  id: string;
  name: string;
  description: string;
  files: string[];
}

export const SKILLS: SkillEntry[] = (manifest as { skills: SkillEntry[] }).skills;

export const skillById = (id: string): SkillEntry | undefined =>
  SKILLS.find((skill) => skill.id === id);

// Ленивые ?raw-импорты: каждый SKILL.md — отдельный чанк, основной бандл не
// растёт с числом навыков.
const RAW = import.meta.glob<string>("../content/skills/*/SKILL.md", {
  query: "?raw",
  import: "default",
});

export function loadSkillMarkdown(id: string): Promise<string> {
  const loader = RAW[`../content/skills/${id}/SKILL.md`];
  if (!loader) return Promise.reject(new Error(`skill markdown missing: ${id}`));
  return loader();
}
